import {useTheme} from '@mui/material';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import {SD_BUTTON_RADIUS} from '../../constants/ui-tokens';

// sow-9 (SIAA-611) standardised radius/height onto shared tokens; draft-day added ariaLabel
// (SIAA-642, admin buttons must carry their own accessible name). Both are kept.
const CustomButton = ({ onClick = () => { }, visible = true, text, variant = 'contained', color = 'secondary', disabled = false, type, disablePadding, loading = false, borderRadius = SD_BUTTON_RADIUS, backgroundColor = '#02140A', textColor = '#fff', hoverColor = '#021209', width = null, height = '40px', selected = false, marginBlock = null, fontWeight = 600, textTransform = null, ariaLabel = null }) => {
  const theme = useTheme();
  const isWhiteText = typeof textColor === 'string' && (
    textColor.toLowerCase() === '#fff' ||
    textColor.toLowerCase() === '#ffffff' ||
    textColor.toLowerCase() === 'white' ||
    textColor.toLowerCase().startsWith('rgba(255')
  );
  const defaultOutlinedHover = isWhiteText ? 'rgba(255, 255, 255, 0.15)' : '#f5f5f5';

  return (
    <Button
      sx={{
        fontWeight: fontWeight,
        visibility: visible ? 'visible' : 'hidden',
        borderRadius: borderRadius,
        backgroundColor: selected ? '#ffffff' : (type === 'outlined' ? 'transparent' : backgroundColor),
        color: selected ? '#000000' : textColor,
        ...(textTransform && {
          textTransform: textTransform
        }),
        ...(width && {
          width: width
        }),
        ...(height && {
          '&&': {
            height,
            minHeight: height,
          },
          padding: disablePadding ? 0 : '0 16px',
          lineHeight: 1.2,
        }),
        border: selected ? '2px solid #000000' : (type === 'outlined' ? `1px solid ${textColor}` : 'none'),
        '&:hover': {
          backgroundColor: selected
            ? '#ffffff'
            : type === 'outlined'
              ? (hoverColor !== '#021209' ? hoverColor : defaultOutlinedHover)
              : hoverColor
        }
      }}
      type={type === 'submit' ? 'submit' : 'button'}
      style={{
        marginBlock: marginBlock !== null
          ? marginBlock
          : disablePadding
            ? theme.spacing(0)
            : theme.spacing(2)
      }}
      variant={variant}
      color={color}
      onClick={onClick}
      // The ACCESSIBLE name, when it must differ from the visible one. Short verb labels
      // ("Save", "Delete") collide across a screen — several modals show a bare Save, and Draft
      // Day has a Save icon button on the page behind them. Duplicate names force positional
      // selectors, which break on every reorder (the F-034 trap). Precedent is already blessed:
      // "Keep Same Group — {groupName}" visible as "Keep Same Group".
      aria-label={ariaLabel || undefined}
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={20} sx={{ color: '#ffffff' }} /> : null}
    >
      {/* Render the AUTHORED string. This was `capitalizeWords(text)`, which force-Title-Cased
          every label AFTER translate() — so Spanish read "Guardar Y Continuar" and Swedish
          "Spara Och Fortsätt", wrong in both. Title Case is an English-only convention. */}
      {loading ? '' : text}
    </Button>
  );
};

export default CustomButton;
